import { API_BASE_URL } from './utils';
import { keycloak } from './keycloak';

const BASE = String(API_BASE_URL).replace(/\/+$/, '');

function buildUrl(endpoint: string) {
  const path = endpoint.replace(/^\/+/, '');
  return `${BASE}/${path}`;
}

async function safeJson(response: Response) {
  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('application/json')) return response.json();
  return null;
}

class HttpHelper {
 public static async checkToken(): Promise<string> {
  const { keycloak } = require('./keycloak');

  if (!keycloak) {
    throw new Error("Keycloak instance could not be loaded from ./keycloak");
  }

  console.log('Is this the real Keycloak?', keycloak instanceof Object);
  console.log('Where does this come from?', keycloak);

  if (!keycloak.authenticated) {
    console.warn("User not authenticated, redirecting...");
    await keycloak.login();
    throw new Error("Redirecting to login...");
  }

  try {
    await keycloak.updateToken(30);
  } catch (error) {
    console.error("Failed to refresh token", error);
    await keycloak.login();
    throw new Error("Session expired");
  }

  if (!keycloak.token) {
    throw new Error("No token available");
  }

  return keycloak.token;
}

  public static async get(endpoint: string) {
    const url = buildUrl(endpoint);

    const jwtToken = await this.checkToken();
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });

    if (!response.ok) {
      const body = await safeJson(response);
      const msg =
        (body && (body.errorMessage || body.message)) ||
        `GET ${url} failed: ${response.status}`;
      throw new Error(msg);
    }

    return safeJson(response);
  }

  public static async getPublic(endpoint: string) {
    const url = buildUrl(endpoint);

    const response = await fetch(url, { method: 'GET' });

    if (!response.ok) {
      const body = await safeJson(response);
      const msg =
        (body && (body.errorMessage || body.message)) ||
        `GET ${url} failed: ${response.status}`;
      throw new Error(msg);
    }

    return safeJson(response);
  }

  public static async post(endpoint: string, data: any) {
    const url = buildUrl(endpoint);
    const jwtToken = await this.checkToken();

    const isFormData = data instanceof FormData;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      },
      body: isFormData ? data : JSON.stringify(data),
    });

    if (!response.ok) {
      const body = await safeJson(response);

      const error: any = new Error(
        (body && (body.errorMessage || body.message)) ||
        `POST ${url} failed: ${response.status}`
      );

      if (body?.errorType) {
        error.errorType = body.errorType;
      }

      throw error;
    }

    return safeJson(response);
  }

  public static async put(endpoint: string, data: any) {
    const url = buildUrl(endpoint);

    const jwtToken = await this.checkToken();
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const body = await safeJson(response);
      const msg =
        (body && (body.errorMessage || body.message)) ||
        `PUT ${url} failed: ${response.status}`;
      throw new Error(msg);
    }

    return safeJson(response);
  }

  public static async delete(endpoint: string) {
    const url = buildUrl(endpoint);

    const jwtToken = await this.checkToken();
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });

    if (!response.ok) {
      const body = await safeJson(response);
      const msg =
        (body && (body.errorMessage || body.message)) ||
        `DELETE ${url} failed: ${response.status}`;
      throw new Error(msg);
    }

    return safeJson(response);
  }
}

export default HttpHelper;